import { render } from "./legal.vue?vue&type=template&id=06f8816c&scoped=true"
import script from "./legal.vue?vue&type=script&lang=js"
export * from "./legal.vue?vue&type=script&lang=js"

import "./legal.vue?vue&type=style&index=0&id=06f8816c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06f8816c"

export default script